<template>
  <div class="login main-login">
    <div class="logo">
      <img src="https://cdn.lessonplan.cn/Public/Logo/logo_old.png" alt="logo">
      <h1>课玩 <span>端应用</span></h1>
    </div>

    <div class="login-form pc">
      <div class="wx-wrapper" v-show="isWxLogin">
        <div id="wx-login-qrcode"></div>
        <button class="wx-login-btn" @click="isWxLogin = false">账号密码登录</button>
      </div>
      <div class="account-wrapper" v-show="!isWxLogin">
        <input type="text" v-model="username" placeholder="请输入手机号码 / 邮箱" class="username">
        <input type="password" v-model="password" placeholder="请输入密码" class="password">
        <button class="login-btn" @click="login()">登 录</button>
        <button class="wx-login-btn" @click="isWxLogin = true">微信登录</button>
        <div class="other">
          <span class="register-tips">没有账号？<a @click="goRegister()">去注册</a></span>
          <a class="forgot-tips" @click="goForgot()">忘记密码</a>
        </div>
      </div>
    </div>
    <div class="login-form mobile">
      <div class="account-wrapper">
        <input type="text" v-model="username" placeholder="请输入手机号码 / 邮箱" class="username">
        <input type="password" v-model="password" placeholder="请输入密码" class="password">
        <button class="login-btn" @click="login()">登 录</button>
        <button class="wx-login-btn mobile" @click="wxloginForMobile()">微信登录</button>
        <div class="other">
          <span class="register-tips">没有账号？<a @click="goRegister()">去注册</a></span>
          <a class="forgot-tips" @click="goForgot()">忘记密码</a>
        </div>
      </div>
    </div>

    <div class="record">
      <a target="_blank" href="https://beian.miit.gov.cn/">黔ICP备18006806号-2 超级课玩 lessonplay.cn</a>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'
import { addQueryString } from '../../util/url'
import { PASSPORT_SERVER, PASSPORT_CLIENT_SERVER, WX_OPEN_SERVER } from '../../config/url'
import { PC_APPID, M_APPID, SCOPE } from '../../config/wx'

export default {
  name: 'login',
  props: {
    redirectURI: String,
  },
  data() {
    return {
      username: '',
      password: '',
      isWxLogin: true,
    }
  },
  mounted() {
    this.wxloginForPC()
  },
  methods: {
    async login() {
      if (!this.username || !this.password) {
        return this.$message.warning('用户名和密码不能为空')
      }

      const key = 'lessonplay_pwd_aes_key_zxc@20260624'
      const encryptedPassword = CryptoJS.AES.encrypt(this.password, key).toString()

      const authRet = await this.$api.passport.auth2({
        username: this.username,
        password: encryptedPassword,
      })
      if (authRet.status !== 1) {
        return this.$message.warning('用户名或密码错误')
      }

      location.href = addQueryString(this.redirectURI, 'token', authRet.token)
    },

    wxloginForPC() {
      // const wxApiRedirectURI = `${PASSPORT_SERVER}/wx/client?redirectURI=${this.redirectURI}`
      const wxApiRedirectURI = `${PASSPORT_SERVER}/wx/client_strict?redirectURI=${this.redirectURI}`

      // eslint-disable-next-line
      new WxLogin({
        id: 'wx-login-qrcode',
        appid: PC_APPID,
        scope: SCOPE,
        redirect_uri: encodeURIComponent(wxApiRedirectURI),
        href: 'https://cdn.lessonplan.cn/Public/CSS/wx-login-style.css',
        fast_login: 1,
      })
    },

    wxloginForMobile() {
      const wxApiRedirectURI = `${PASSPORT_CLIENT_SERVER}/wx?redirectURI=${this.redirectURI}`
      // location.href = `${WX_OPEN_SERVER}/connect/oauth2/authorize?appid=${M_APPID}&redirect_uri=${wxApiRedirectURI}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
      location.href = `${WX_OPEN_SERVER}/connect/oauth2/authorize?appid=${M_APPID}&redirect_uri=${wxApiRedirectURI}&response_type=code&scope=snsapi_userinfo&state=strict#wechat_redirect`
    },

    goForgot() {
      this.$router.push({ name: 'forgot', query: { redirectURI: this.redirectURI } })
    },

    goRegister() {
      this.$router.push({ name: 'register', query: { redirectURI: this.redirectURI } })
    },
  }
}
</script>

<style lang="scss" scoped>
button {
  margin: 5px 0;
}

.login {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;

  img {
    margin-left: 16px;
    width: 88px
  }

  h1 {
    span {
      font-size: 17px;
      color: #555;
    }
  }

  p {
    font-size: 15px;
    color: #777;
    margin-top: 12px;
    margin-bottom: 10px;
  }
}

.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  &.pc {
    display: block;
  }

  &.mobile {
    display: none;
  }
}

.wx-wrapper,
.account-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.login-btn {
  color: #fff;
}

.wx-login-btn {
  background: #fff;
  color: #1a7733;
  border: 1px solid #1a7733;
  margin-top: 12px;
  box-shadow: none;
  margin-top: 8px;
}

.other {
  width: 270px;
  font-size: 14px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;

  a {
    color: #666;
  }
}

/* PC端微信登录弹出二维码 */
#wx-login-qrcode {
  width: 280px;
  height: 320px;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  iframe {
    height: 280px !important;
  }
}

@media only screen and (max-width: 720px) {
  .login-form {
    &.mobile {
      display: block;
    }

    &.pc {
      display: none;
    }
  }

  #wx-login-qrcode {
    display: none;
  }
}

@media only screen and (max-height: 850px) and (min-width: 720px) {
  .logo img {
    display: none;
  }
}
</style>

<style lang="scss">
#wx-login-qrcode {
  iframe {
    height: 340px !important;
  }
}
</style>